export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const TOKEN_REFRESHED = "TOKEN_REFRESHED";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const CHECK_LOGIN_SUCCESS = "CHECK_LOGIN_SUCCESS";
export const CHECK_LOGIN_FAILED = "CHECK_LOGIN_FAILED";
export const SEND_PASSWORD_RESET_EMAIL = "SEND_PASSWORD_RESET_EMAIL";
export const SET_USER = "SET_USER";
export const TRIAL_EXPIRED = "TRIAL_EXPIRED";
export const CLEAR_TRIAL_EXPIRED = "CLEAR_TRIAL_EXPIRED";
export const LOGIN_WITH_REFRESH_TOKEN = "LOGIN_WITH_REFRESH_TOKEN";
